import React from 'react';
import { authenticationSlice } from '@cp/shared/api/core';
import { useDispatch } from 'react-redux';
import { coreAdminAuthApi } from '../api';

export const useLogout = () => {
  const [logout, { isLoading }] = coreAdminAuthApi.endpoints.logout.useMutation();
  const dispatch = useDispatch();

  return {
    logout: React.useCallback(async () => {
      await logout();
      dispatch(authenticationSlice.actions.setToken(null));
    }, [dispatch, logout]),
    isLoading,
  };
};
